<template>
  <div class="container">
    <gobuy-head :title="$t('My Wallet')" />
    <div class="zhanweifu" style="height: 4.2rem;" v-if="!$IFR.is_iframe"></div>

    <body>
      <div style="padding-bottom: 1px;">
        <div class="div account_header">
          <div class="div predeposit">
            <span class="predeposit_title">{{ $t("Available Balance") }}</span>
            <span class="available_predeposit">${{ available_predeposit }}</span>
          </div>
          <div class="div amount-wrapper">
            <div class="div amount_item">
              {{ $t("The withdrawal is being processed") }}:
              <span style="color: rgba(232, 9, 12, 1); font-size: 15px"
                >${{ freeze_predeposit }}</span
              >
            </div>
          </div>
          <div class="div predeposit_handle mt-5">
            <div
              class="div item"
              @click="$router.push({ name: 'MemberRechargeList' })"
            >
              <span class="ds-button">{{ $t("Recharge") }}</span>
            </div>
            <div
              class="div item"
              @click="$router.push({ name: 'MemberWithdrawList' })"
            >
              <span class="ds-button">{{ $t("Withdraw") }}</span>
            </div>
          </div>
          <div class="address">
            <div class="box addicon" v-if="btnShow" @click="goAdd">
              <div class="v">{{ $t("Add Recipient Account First") }}</div>
              <div class="add">+</div>
            </div>
            <div class="box" v-else>
              <div class="t" v-if="bank_list[0].address_type == 'opBNB'">USDT Address (opBNB): </div>
              <div class="t" v-else>USDT-BNB Smart Chain (BEP20):</div>
              <div class="v">{{ bank_list[0].memberbank_no }}</div>
            </div>
          </div>
        </div>
  
        <div class="div account mt-5">
          <div class="div menu">
          </div>
        </div>
        <div class="data">
          <div class="tit">{{ $t("Fund Details") }}</div>
          <div class="fundet">
            <div
              v-infinite-scroll="loadMore"
              infinite-scroll-disabled="loading"
              infinite-scroll-distance="10"
              style="padding-bottom: 100px"
            >
              <div
                class="list-wrapper"
                v-if="predeposit_list && predeposit_list.length"
              >
                <div
                  class="item"
                  v-for="(item, index) in predeposit_list"
                  :key="item.lg_id"
                >
                  <label class="subtitle">{{ item.lg_desc }}</label>
                  <div class="dataTime">
                    <label class="title">{{ item.lg_addtime_text }}</label>
                    <label
                      class="date"
                      v-bind:class="item.lg_av_amount > 0 ? 'income' : 'expend'"
                    >
                      ${{ item.lg_av_amount > 0 ? "+" : ""
                      }}{{ item.lg_av_amount }}
                    </label>
                  </div>
                </div>
              </div>
              <empty-record
                v-else-if="predeposit_list && !predeposit_list.length"
              ></empty-record>
            </div>
          </div>
        </div>
      </div>
    </body>
  </div>
</template>

<script>
import { Toast, Indicator } from "mint-ui";
import { getMemberIndex } from "../../../api/member";
import { getPredepositList } from "../../../api/memberPredeposit";
import { getBankList } from "../../../api/memberBank";
import { mapState } from "vuex";
import flexLine from "../../flexLine";
import EmptyRecord from "../../../components/EmptyRecord";
export default {
  components: {
    flexLine,
    EmptyRecord,
  },
  data() {
    return {
      available_predeposit: 0.0,
      freeze_predeposit: 0.0,
      voucher_count: 0,
      points: 0,
      available_rc_balance: 0,
      params: { page: 0, per_page: 10 },
      loading: false, // 是否加载更多
      isMore: true, // 是否有更多
      predeposit_list: false,
      btnShow: true,
      bank_list: null,

      scrollY: 0,
      startChangeAt: 20, // 开始改变背景色的滚动阈值
      maxOpacity: 1, // 最大不透明度
      opacityMultiplier: 20, // 滚动距离到最大不透明度的倍数
    };
  },
  created() {
    this.getBankList();

    getMemberIndex().then(
      (response) => {
        if (response && response.result.member_info) {
          this.available_predeposit =
            response.result.member_info.available_predeposit;
          this.freeze_predeposit =
            response.result.member_info.freeze_predeposit;
          this.voucher_count = response.result.member_info.voucher_count;
          this.points = response.result.member_info.member_points;
          this.available_rc_balance =
            response.result.member_info.available_rc_balance;
        }
      },
      (error) => {}
    );
  },
  computed: {
    headerStyle() {
      let newOpacity = Math.min(
        this.maxOpacity,
        (this.scrollY - this.startChangeAt) / this.opacityMultiplier
      );
      if (this.scrollY > this.startChangeAt) {
        return { backgroundColor: `rgba(255, 255, 255, ${newOpacity})` };
      } else {
        return { backgroundColor: "transparent" };
      }
    },
  },
  mounted() {
    window.scrollTo(0, 0);
    window.addEventListener("scroll", this.handleScroll);
  },
  beforeDestroy() {
    window.removeEventListener("scroll", this.handleScroll);
  },
  methods: {
    handleScroll() {
      this.scrollY = window.pageYOffset || document.documentElement.scrollTop;
    },
    goAdd() {
      this.$router.push({ name: "MemberBankForm", query: { action: "add" } });
    },
    getBankList() {
      getBankList()
        .then((res) => {
          this.bank_list = res.result.bank_list;
          if (this.bank_list.length > 0) {
            this.btnShow = false;
          } else {
            this.btnShow = true;
          }
        })
        .catch(function (error) {
          Toast(error.message);
        });
    },
    loadMore() {
      this.loading = true;
      this.params.page = ++this.params.page;
      if (this.isMore) {
        this.loading = false;
        this.getPredepositList(true);
      }
    },
    getPredepositList() {
      Indicator.open();
      getPredepositList(this.params)
        .then((res) => {
          Indicator.close();
          if (res.result.hasmore) {
            this.isMore = true;
          } else {
            this.isMore = false;
          }

          let temp = res.result.list;
          if (temp) {
            if (!this.predeposit_list) {
              this.predeposit_list = temp;
            } else {
              this.predeposit_list = this.predeposit_list.concat(temp);
            }
          }
        })
        .catch(function (error) {
          Indicator.close();
          Toast(error.message);
        });
    },
  },
};
</script>

<style scoped lang="scss">
.container {
  height: 100%;
  box-sizing: border-box;
}

.common-header-wrap {
  position: fixed;
  top: 54px;
  width: 100%;
  .common-header {
    background: rgba(232, 9, 12, 0.6);
    color: #fff;
    box-shadow: none;
  }
}
.logo {
  position: fixed;
  top: 25px;
  left: 12px;
  z-index: 99;

  img {
    width: 3.5rem;
  }
}
body {
  width: 100%;
  background-color: transparent;
  top: 100px;
  padding-top: 1px;
}
.account_header {
  color: black;
  padding: 0.7rem 12px;
  font-size: $fontSize;
  box-sizing: border-box;
  margin: 20px 12px;
  border-radius: 12px;
  border: 1px solid RGBA(249, 163, 127, 1);
  .predeposit {
    padding: 0.5rem 0;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;

    .predeposit_title {
      font-size: 1rem;
      color: black;
      margin-bottom: 0.5rem;
    }

    .available_predeposit {
      color: #fb2732;
      font-size: 1.5rem;
    }
  }

  .amount-wrapper {
    margin-top: 1rem;
    overflow: hidden;

    .amount_item {
      color: black;
      text-align: center;
    }

    .amount_item:nth-child(2) {
      text-align: right;
    }
  }
}

.card-wrapper {
  background-color: #fff;
  display: flex;
  padding: 0.5rem 0;
  justify-content: center;
  align-items: center;

  .card_item {
    width: 36%;
    margin: 0 6%;
    background-color: #f5a623;
    padding: 0.8rem 0;
    border-radius: 0.5rem;
    text-align: center;

    .img {
      width: 1.5rem;
      height: 1.5rem;
    }

    .explain {
      font-size: $subFontSize;
      color: #fff;
    }
  }

  .card_item:nth-child(3) {
    background-color: #ff862f;
  }

  .border {
    width: 1px;
    background-color: #cdcdcd;
    height: 2.8rem;
  }
}
.predeposit_handle {
  margin-top: 30px !important;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: stretch;
  background-color: transparent;

  .item {
    display: flex;
    justify-content: center;
    align-items: center;
    flex: 1;

    .img {
      width: 3rem;
    }

    span {
      width: 5rem;
      text-align: center;
      background: linear-gradient(90deg, #e8090c 0%, #f3611e 100%);
      border-radius: 50px;
      padding: 0.5rem;
      font-size: 0.9rem;
      color: #ffffff;
    }
  }
}

.account {
  padding: 0 $pageSpace;
  background: #fff;

  .menu {
    background: #fff;
  }
}

.address {
  padding: 0.9rem 0.7rem;
  margin: 1rem 0px 0px 0px;
  border-radius: 3px 3px 0 0;

  .addicon {
    display: flex;
    justify-content: space-between;
    align-items: center;

    .add {
      display: flex;
      justify-content: center;
      align-items: center;
      width: 2rem;
      height: 1.2rem;
      background: linear-gradient(90deg, #e8090c 0%, #f3611e);
      color: #fff;
      font-size: 20px;
      border-radius: 50px;
    }
  }

  .t {
    font-size: 13px;
    margin-bottom: 0.2rem;
    color: #a62c22;
  }

  .v {
    word-wrap: break-word; /* 或者使用 overflow-wrap: break-word; */
    white-space: normal; /* 确保文本会换行 */
    font-size: 15px;
    color: RGBA(255, 73, 73, 1);
  }
}
.data {
  padding: 0px 12px;
}
.tit {
  display: inline-block;
  color: black;
  font-size: 18px;
  border-bottom: none; /* 取消默认下划线 */
  background-image: linear-gradient(
    90deg,
    #e8090c 30%,
    #f3611e 20%,
    RGBA(240, 240, 240, 1) 50%
  );
  background-size: 100% 5px; /* 下划线的高度 */
  background-repeat: no-repeat;
  background-position: bottom;
}
.fundet {
  margin-top: 20px;
  border-radius: 25px 25px 0 0;
}

.list-wrapper {
  padding: .5rem;
  background: #ffffff;
  height: 15.5rem;
  overflow-y: auto;
  border-radius: 15px;

  .item {
    padding: 10px;
    display: flex;
    position: relative;
    justify-content: center;
    flex-direction: column;
    justify-content: flex-start;
    align-items: stretch;
    background-color: #fff;
    border-bottom: 1px solid #e8eaed;

    &:last-child {
      border-bottom: none;
    }

    .title {
      font-size: 16px;
      margin-bottom: 0.5rem;
    }

    .income {
      color: $primaryColor;
    }

    .expend {
      color: #333;
    }

    .subtitle {
      font-size: $fontSize;
    }
  }

  .title {
    font-size: $h1;
    margin-left: 0.7rem;
  }

  .income {
    color: $primaryColor;
  }

  .expend {
    color: #333;
  }

  .subtitle {
    font-size: $fontSize;
    color: #666;
    padding-bottom: 8px;
  }
  .dataTime {
    display: flex;
    justify-content: space-between;
    align-items: center;
  }
  .date {
    color: #e8090c;
    font-size: 18px;
    // position: absolute;
    top: 2.2rem;
    right: 0.7rem;
    font-weight: bold;
  }
}
</style>
